import { FC } from "react";

import { Grid } from "@mui/material";

import LastUpdated from "@shared-containers/LastUpdated";
import SummaryType from "./SummaryType";
import { getMappedSummaryData } from "./helper";
import { LastUpdatedWrapper } from "../../CheckDashboard/CheckSummary/style";

interface SummaryContentPropsType {
  summaryData: NotificationSummaryDataType;
  lastUpdatedTime: string;
  loading: boolean;
}

const SummaryContent: FC<SummaryContentPropsType> = ({
  summaryData,
  lastUpdatedTime,
  loading,
}) => {
  const mappedSummaryData = getMappedSummaryData(summaryData);

  return (
    <>
      <Grid style={{ marginTop: 8 }} direction="row" container>
        {mappedSummaryData?.map((i) => (
          <SummaryType loading={loading} type={i?.type} value={i.value} />
        ))}
      </Grid>
      <LastUpdatedWrapper>
        <LastUpdated loading={loading} lastUpdatedTime={lastUpdatedTime} />
      </LastUpdatedWrapper>
    </>
  );
};

export default SummaryContent;
